/**
 * <card-swatch> — the colour swatch row on product cards (snippets/product-swatch.liquid).
 *
 * Shows as many swatches as fit on ONE row. When they don't all fit, the last
 * slot becomes "+N" (N = hidden count) and the rest get .is-overflow. Tapping
 * "+N" is handled by theme.js, which toggles .show--more on the <ul>; CSS then
 * reveals the overflow and wraps the row.
 *
 * Re-fits on resize, so it follows the card's real width in every context
 * (grid columns, carousels, predictive search, AJAX-loaded pages) without
 * per-breakpoint limits. Rows rendered with data-limit (a fixed server-side cap,
 * e.g. dynamic-grid hero tiles) are left alone.
 */
if (!customElements.get('card-swatch')) {
    class CardSwatch extends HTMLElement {
        connectedCallback() {
            if (this.hasAttribute('data-limit')) return;
            this.list = this.querySelector('.swatch');
            this.more = this.querySelector('.item-swatch-more');
            if (!this.list || !this.more) return;
            this.items = [...this.list.children].filter((li) => li !== this.more);
            this.lastWidth = -1;
            this.observer = new ResizeObserver(() => this.fit());
            this.observer.observe(this.list);
        }

        disconnectedCallback() {
            this.observer?.disconnect();
        }

        fit() {
            const width = this.list.clientWidth;
            // Hidden (display:none) cards report 0 — keep the last good layout.
            if (!width || width === this.lastWidth) return;
            this.lastWidth = width;

            const gap = parseFloat(getComputedStyle(this.list).columnGap) || 0;
            const itemWidth = this.items[0].offsetWidth;
            const total = this.items.length;
            const rowWidth = (count) => count * itemWidth + Math.max(count - 1, 0) * gap;

            let visible = total;
            if (rowWidth(total) > width) {
                // Size the counter for the worst case before measuring it.
                this.setMore(total);
                const moreWidth = this.more.offsetWidth + gap;
                visible = Math.max(Math.floor((width - moreWidth + gap) / (itemWidth + gap)), 1);
            }

            this.items.forEach((li, i) => li.classList.toggle('is-overflow', i >= visible));
            this.setMore(total - visible);
        }

        setMore(count) {
            this.more.hidden = count === 0;
            this.more.querySelector('.text-number').textContent = count;
        }
    }

    customElements.define('card-swatch', CardSwatch);
}
